import { RootState } from 'store/rootReducer';

export const MyRequestContentSelector = (state: RootState) => state.content.myRequest;
